import { useState, useCallback } from 'react';
import { apiService } from '../../../services/api';
import type { BulkUploadRequest, BulkUploadResponse } from '../../../types';

export function useBulkUpload() {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [result, setResult] = useState<BulkUploadResponse['result'] | null>(null);

  const upload = useCallback(async (data: BulkUploadRequest): Promise<boolean> => {
    setIsUploading(true);
    setUploadError(null);
    try {
      const response = await apiService.bulkUpload(data);
      setResult(response.result);
      return true;
    } catch (err) {
      setUploadError(err instanceof Error ? err.message : '登録に失敗しました');
      return false;
    } finally {
      setIsUploading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setUploadError(null);
  }, []);

  return { isUploading, uploadError, result, upload, reset };
}
